'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvedAttachmentsForThreadFromProps = undefined;

var _reselect = require('reselect');

var _immutable = require('immutable');

var _statusComparators = require('conversations-async-data/async-data/operators/statusComparators');

var _getters = require('conversations-async-data/async-data/operators/getters');

var _resolvedAttachmentEntriesForThreadFromProps = require('./resolvedAttachmentEntriesForThreadFromProps');

var resolvedAttachmentsForThreadFromProps = exports.resolvedAttachmentsForThreadFromProps = (0, _reselect.createSelector)([_resolvedAttachmentEntriesForThreadFromProps.resolvedAttachmentEntriesForThreadFromProps], function (entries) {
  if (!entries) {
    return (0, _immutable.Map)();
  }

  return entries.filter(_statusComparators.isSucceeded).map(_getters.getData);
});